import React from 'react';
import { Phone, Mail, MapPin, Facebook, Instagram } from 'lucide-react';
import { businessInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <img 
                src="/otl_logo.png" 
                alt="Obućar Tašner Laki Logo" 
                className="h-16 w-auto"
              />
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Majstorska radionica sa tradicijom i iskustvom. Vaše zadovoljstvo je naša najveća nagrada.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">Brzi linkovi</h4>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => scrollToSection('hero')}
                  className="text-gray-400 hover:text-orange-400 transition-colors text-sm"
                >
                  Početna
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('usluge')}
                  className="text-gray-400 hover:text-orange-400 transition-colors text-sm"
                >
                  Usluge
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('o-nama')}
                  className="text-gray-400 hover:text-orange-400 transition-colors text-sm"
                >
                  O nama
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('galerija')}
                  className="text-gray-400 hover:text-teal-400 transition-colors text-sm"
                >
                  Galerija
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('kontakt')}
                  className="text-gray-400 hover:text-orange-400 transition-colors text-sm"
                >
                  Kontakt
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold mb-4">Naše usluge</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>Popravka obuće</li>
              <li>Popravka tašni</li>
              <li>Popravka kofera</li>
              <li>Kožna galanterija</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-4">Kontakt</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-teal-400 flex-shrink-0 mt-0.5" />
                <span className="text-sm text-gray-400">
                  {businessInfo.address.street}<br />
                  {businessInfo.address.city}
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-teal-400 flex-shrink-0" />
                <a 
                  href={`tel:${businessInfo.phoneRaw}`}
                  className="text-sm text-gray-400 hover:text-teal-400 transition-colors"
                >
                  {businessInfo.phone}
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-blue-400 flex-shrink-0" />
                <a 
                  href={`mailto:${businessInfo.email}`}
                  className="text-sm text-gray-400 hover:text-blue-400 transition-colors break-all"
                >
                  {businessInfo.email}
                </a>
              </li>
            </ul>

            {/* Social Media - Placeholder */}
            <div className="mt-6 flex space-x-3">
              <a 
                href="#" 
                className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-teal-600 transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a 
                href="#" 
                className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-teal-600 transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-400 text-center md:text-left">
              © {currentYear} Obućar Tašner Laki. Sva prava zadržana.
            </p>
            <p className="text-sm text-gray-400">
              {businessInfo.workingHours.weekdays}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
